module.exports = "pegasus_template/assets/tech/safari/104.png";